module.exports = __webpack_public_path__ + "static/media/bliss_truck_end.8c027ff4.png";